import { profils } from "../data/profils";

// Normalisation pour la comparaison des noms (sans accents, insensible à la casse)
const normalize = (str) => str.normalize("NFD").replace(/\p{Diacritic}/gu, "").toLowerCase();

// Récupère l'ID du profil à partir du nom dans l'URL
export const getProfilIdFromUrlName = () => {
  const match = window.location.pathname.match(/^\/([^\/]+)(?:\/|$)/);
  if (match) {
    const nameInUrl = normalize(decodeURIComponent(match[1]));
    for (const [id, profil] of Object.entries(profils)) {
      if (normalize(profil.name) === nameInUrl) {
        return parseInt(id);
      }
    }
  }
  return 1; // Par défaut Carole
};

// Récupère le profil à partir de l'ID
export const getProfil = (profilId) => profils[profilId] || profils[1];

// Remplace dynamiquement la première image du flow initial par l'avatar du profil
export const setFirstMessageAvatar = (mx, profil) => {
  if (mx.messages.length > 0 && mx.messages[0].type === "image") {
    mx.messages[0].src = profil.avatar;
    mx.messages[0].alt = `Photo de profil de ${profil.name}`;
  }
};

// Génère dynamiquement le lien de déblocage à envoyer au client
export const generateUnlockLink = (profilId, token) => {
  // On récupère le prénom 
  const prenom = profils[profilId]?.name || "";
  // Encodage du prénom
  const safePrenom = encodeURIComponent(prenom);
  // URL externe
  return `http://tr.des-rencontres.com/ckmob.php?lp=1&t30=${safePrenom}`;
};